const ModalBalanaces = ({modalBalances, setModalBalances}) => {
   
   return (
      <>
         <div className={`popup ${modalBalances}`} id="popup">
            <div className='overlay'></div>
            <div className='popup-content'>
               {/* <div className="modal-prelogin-picture">
                  <img src={logoLatitud} alt="" className="responsive-img modal-prelogin-img"/>
               </div> */}
               <h2>Balances de Latitud Sur SA</h2>
               <p>
                  Seleccione el qué desee descargar
               </p>
                  <div className="row">
                     <div className="col s12 m12">
                        <ul id="nav-mobile" className="nav-center hide-on-med-and-down">
                           <li><a target='_blank' className="btn-balance" rel="noopener noreferrer"  href={`${process.env.REACT_APP_API_URL}/web/downloadBalance/balanceContable300624.pdf`}>Balance Contable 30-06-24</a></li>
                           <li><a target='_blank' className="btn-balance" rel="noopener noreferrer"  href={`${process.env.REACT_APP_API_URL}/web/downloadBalance/balanceContable300625.pdf`}>Balance Contable 30-06-25</a></li>
                           <li><a target='_blank' className="btn-balance" rel="noopener noreferrer"  href={`${process.env.REACT_APP_API_URL}/web/downloadBalance/balanceContable300626.pdf`}>Balance Contable 30-06-26</a></li>
                        </ul>
                     </div>
                  </div>
               <div className='controls'>
                  <button className='submit-btn' onClick={()=>setModalBalances("")}>Cerar</button>
               </div>
            </div>
         </div>
      </>
   )
}

export default ModalBalanaces;